import { render, staticRenderFns } from "./AccountLanguages.vue?vue&type=template&id=58c8e551"
import script from "./AccountLanguages.vue?vue&type=script&lang=js"
export * from "./AccountLanguages.vue?vue&type=script&lang=js"
import style0 from "./AccountLanguages.vue?vue&type=style&index=0&id=58c8e551&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports